// extracted by mini-css-extract-plugin
module.exports = {"lia-text-style":"FormFeedback_lia-text-style__S7tEt"};